const initState = {
  authError: null,
  successRecover: null
}

const authReducer = (state = initState, action) => {
  switch(action.type){
    case 'LOGIN_ERROR':
      return {
        ...state,
        authError: 'Login failed'
      }

    case 'LOGIN_SUCCESS':
      return {
        ...state,
        authError: null
      }

    case 'SIGNOUT_SUCCESS':
      return {
        ...state,
        successRecover: "Sesión cerrada con éxito",
        authError: null
      }

    case 'RECOVER_SUCCESS':
      return {
        ...state,
        successRecover: "Hemos enviado un correo a tu cuenta para recuperar tu contraseña",
        authError: null
      }
  
    case 'RECOVER_ERROR':
      return {
        ...state,
        successRecover: null,
        authError: action.err.message
      }

    default:
      return state
  }
};

export default authReducer;